export default "__VITE_ASSET__e1919c6c__"